import React from "react";
import { HeroSection } from "..";

/**
 * ProjectHero
 * Thin wrapper around HeroSection applying consistent defaults.
 */
const ProjectHero = ({
  mediaType,
  mediaSrc,
  mediaAlt,
  logoSrc,
  subtitle,
  description,
  showLogo = true,
  darkOverlay = true,
  overlayOpacity = 0.15,
  textPosition = "bottom-left",
  sx = { borderRadius: 0 },
  ...rest
}) => {
  return (
    <HeroSection
      mediaType={mediaType}
      mediaSrc={mediaSrc}
      mediaAlt={mediaAlt}
      logoSrc={logoSrc}
      subtitle={subtitle}
      description={description}
      showLogo={showLogo}
      darkOverlay={darkOverlay}
      overlayOpacity={overlayOpacity}
      textPosition={textPosition}
      mediaLoading="eager"
      sx={sx}
      {...rest}
    />
  );
};

export default ProjectHero;
